import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css"; // Import AOS styles
import React, { useEffect, useState } from "react";
import data from "../../src/component/ApiUrl/meta_api";
import { Helmet } from "react-helmet";
import { FaChevronRight, FaCheck } from "react-icons/fa";
import "../assets/css/Delta.css";

function Delta() {
  const [meta, setMeta] = useState(null);

  const fetchData = () => {
    const DeltaMeta = data[0]?.Seimens_page;
    if (DeltaMeta) {
      setMeta(DeltaMeta);
    }
  };

  useEffect(() => {
    fetchData();
    AOS.init({
      duration: 2000,
      once: true,
    });
  }, []);

  return (
    <>
      <div
        className="container-fluid page-header py-5 mb-5 wow fadeIn"
        data-wow-delay="0.1s"
      >
        <Helmet>
          <title>{meta ? meta.title : "Delta - SKimitar Hindustan"}</title>
          <meta
            name="description"
            content="Learn about Skimitar Hindustan's PLC,HMI and Variable Frequency Drives in industrial automation solutions."
          />
        </Helmet>
        <div className="container py-5">
          <h1 className="display-3 text-white animated slideInRight">Delta</h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb animated slideInRight mb-0">
              <li className="breadcrumb-item text-white-50">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item text-white">
                <Link to="/">Products</Link>
              </li>
              <li
                className="breadcrumb-item active text-white"
                aria-current="page"
              >
                Delta
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <div className="container py-5">
        <div className="row g-4">
          <div
            className="col-lg-5 col-md-6 order-md-1 order-2 d-flex align-items-center"
            data-aos="fade-right"
          >
            <div className="card border-0 shadow-lg overflow-hidden h-100">
              <img
                className="card-img-top img-fluid"
                src={require("../assets/img/products/Delta/Delta Industrial Automation-1.png")}
                alt="Delta Automation"
                style={{ objectFit: "cover", height: "300px" }}
              />
              <div className="card-body bg-light">
                <h5 className="card-title text-danger">
                  Industrial Automation Excellence
                </h5>
                <p className="card-text fs-6 justified-text">
                  Cutting-edge solutions for modern manufacturing Streamline
                  operations and boost productivity with smart, reliable
                  automation systems.
                </p>
              </div>
            </div>
          </div>

          <div
            className="col-lg-7 col-md-6 order-md-2 order-1"
            data-aos="fade-left"
          >
            <div className="card border-0 h-100">
              <div className="card-body p-4 p-md-5">
                <div className="d-flex align-items-center mb-4">
                  <span className="bg-primary bg-opacity-10 text-danger p-3 rounded-circle me-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1zm3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4h-3.5z" />
                    </svg>
                  </span>
                  <h2 className="card-title mb-0 text-dark">
                    Delta Industrial{" "}
                    <span className="text-danger">Automation</span>
                  </h2>
                </div>

                <p className="card-text lead fs-6 mb-4 justified-text">
                  Delta Electronics delivers innovative industrial automation
                  solutions that drive efficiency, precision and reliability
                  across manufacturing operations worldwide.
                </p>

                <div className="row g-3">
                  <div className=" col-lg-4 col-md-12 col-sm-12">
                    <div className="card bg-danger bg-opacity-10 border-primary border-opacity-25 h-100">
                      <div className="card-body">
                        <div className="d-flex align-items-center mb-2">
                          <span className="bg-danger text-white p-2 rounded me-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              viewBox="0 0 16 16"
                            >
                              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z" />
                            </svg>
                          </span>
                          <h6 className="mb-0 text-danger">AC Motor Drives</h6>
                        </div>
                        <p className="small fs-6 smb-0">
                          Precision control for optimal motor performance
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-12 col-sm-12">
                    <div className="card bg-danger bg-opacity-10 border-success border-opacity-25 h-100">
                      <div className="card-body">
                        <div className="d-flex align-items-center mb-2">
                          <span className="bg-danger text-white p-2 rounded me-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              viewBox="0 0 16 16"
                            >
                              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z" />
                            </svg>
                          </span>
                          <h6 className="mb-0 text-danger">
                            Power Regeneration
                          </h6>
                        </div>
                        <p className="small fs-6 mb-0">
                          Energy recovery for sustainable operations
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-12 col-sm-12">
                    <div className="card bg-danger bg-opacity-10 border-info border-opacity-25 h-100">
                      <div className="card-body">
                        <div className="d-flex align-items-center mb-2">
                          <span className="bg-danger text-white p-2 rounded me-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              viewBox="0 0 16 16"
                            >
                              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z" />
                            </svg>
                          </span>
                          <h6 className="mb-0 text-danger">Power Filters</h6>
                        </div>
                        <p className="small fs-6 mb-0">
                          Clean power for sensitive equipment
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container py-5">
        <div className="row ">
          <div
            className="col-lg-6 col-md-6 order-md-2 order-1"
            data-aos="fade-left"
          >
            <div className="card border-0 shadow-lg overflow-hidden ">
              <img
                className="card-img-top img-fluid"
                src={require("../assets/img/products/Delta/Motion Control Motion-2.png")}
                alt="Delta Automation"
                style={{ objectFit: "cover", height: "300px" }}
              />
              <div className="card-body bg-light">
                <h5 className="card-title text-danger">
                  Motion Control Systems
                </h5>
                <p className="card-text fs-6 justified-text">
                  This category includes servo drives, motors, and motion
                  controllers that deliver precise control for complex
                  machinery, enhancing productivity and product quality.
                </p>
              </div>
            </div>
          </div>

          <div
            className="col-lg-6 col-md-6 order-md-1 order-2 d-flex align-items-center"
            data-aos="fade-right"
          >
            <div className="card border-0 h-100">
              <div className="card-body p-4 p-md-5">
                <div className="d-flex align-items-center mb-4">
                  <h2 className="card-title mb-0 text-dark">
                    Motion
                    <span className="text-danger"> Control </span>
                  </h2>
                </div>

                <p className="card-text lead fs-6 mb-4 justified-text">
                  Motion control systems play a pivotal role in modern
                  automation, enabling precise and efficient control of
                  machinery. By integrating components such as servo drives,
                  motors, and motion controllers, these systems allow for the
                  accurate positioning and synchronization of equipment in a
                  wide range of industries.
                </p>

                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="card bg-danger bg-opacity-10 border-primary border-opacity-25 h-100">
                      <div className="card-body">
                        <div className="d-flex align-items-center mb-2">
                          <h5 className="mb-0 text-danger">
                            Servo Drives & Motors{" "}
                          </h5>
                        </div>
                        <p className="small fs-6 mb-0">
                          Precision control for optimal motor performance,
                          ensuring high efficiency.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="card bg-danger bg-opacity-10 border-success border-opacity-25 h-100">
                      <div className="card-body">
                        <div className="d-flex align-items-center mb-2">
                          <h5 className="mb-0 text-danger">
                            Motion Controllers
                          </h5>
                        </div>
                        <p className="small fs-6 mb-0">
                          Energy recovery technology for a more sustainable
                          operational approach.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container py-5 ">
        <div className="row g-5 align-items-center">
          <div className="col-lg-6" data-aos="fade-left">
            <div className="">
              <div className="d-flex align-items-center">
                <h2
                  className="text-gradient-primary fw-bold fs-2 mb-4"
                  data-aos="fade-left"
                >
                  Industrial Control & Communication
                </h2>
              </div>

              <p className="lead fs-6 mb-4 justified-text">
                Delta's advanced automation solutions deliver precision control
                and seamless communication for modern industrial applications,
                ensuring reliability and efficiency across your operations.
              </p>

              <div className="row g-3 mb-4">
                <div className="col-md-6">
                  <div className="p-3 bg-light rounded-3 h-100 border-start border-3 border-danger">
                    <h5 className="text-danger mb-3">Key Advantages</h5>
                    <ul className="list-unstyled mb-0">
                      <li className="mb-2 d-flex">
                        <span className="text-danger me-2">•</span>
                        <span>High-performance PLC systems</span>
                      </li>
                      <li className="mb-2 d-flex">
                        <span className="text-danger me-2">•</span>
                        <span>Industrial-grade networking</span>
                      </li>
                      <li className="d-flex">
                        <span className="text-danger me-2">•</span>
                        <span>Scalable modular designs</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="p-3 bg-light rounded-3 h-100 border-start border-3 border-danger">
                    <h5 className="text-danger mb-3">Technical Benefits</h5>
                    <ul className="list-unstyled mb-0">
                      <li className="mb-2 d-flex">
                        <span className="text-danger me-2">•</span>
                        <span>Robust communication protocols</span>
                      </li>
                      <li className="mb-2 d-flex">
                        <span className="text-danger me-2">•</span>
                        <span>High-speed data processing</span>
                      </li>
                      <li className="d-flex">
                        <span className="text-danger me-2">•</span>
                        <span>Seamless system integration</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="bg-light-subtle p-4 rounded-3 mb-4">
                <h3
                  className="text-gradient-primary fw-bold fs-5 mb-4"
                  data-aos="fade-left"
                >
                  Featured Product
                </h3>
                <div className="row g-3">
                  <div className="col-md-4">
                    <div className="bg-white p-3 rounded-3 shadow-sm h-100">
                      <h6 className="text-danger mb-2">DVP Series PLCs</h6>
                      <p className="small text-muted mb-0">
                        Compact, cost-effective automation
                      </p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="bg-white p-3 rounded-3 shadow-sm h-100">
                      <h6 className="text-danger mb-2">AS Series PLCs</h6>
                      <p className="small text-muted mb-0">
                        High-performance control
                      </p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="bg-white p-3 rounded-3 shadow-sm h-100">
                      <h6 className="text-danger mb-2">Ethernet Switches</h6>
                      <p className="small text-muted mb-0">
                        Industrial networking
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6" data-aos="fade-right">
            <div className="position-relative rounded-4 overflow-hidden shadow-lg h-100">
              <img
                className="img-fluid w-100"
                src={require("../assets/img/products/Delta/Industrial Control & Communication.png")}
                alt="Industrial Control"
                style={{ minHeight: "500px", objectFit: "cover" }}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid bg-white py-5">
        <div className="container">
          <div className="row justify-content-center mb-5">
            <div className="col-lg-10 text-center">
              <h2 className="fs-3 fw-bold text-danger mb-3">
                Next-Gen Human Machine Interfaces
              </h2>
            </div>
          </div>

          <div className="row g-4">
            <div className="col-lg-4">
              <div className="card h-100 border-0 rounded-4 overflow-hidden shadow-sm hover-shadow-lg transition-all">
                <div
                  className="card-img-top overflow-hidden"
                  style={{ height: "200px" }}
                >
                  <img
                    src={require("../assets/img/products/Delta/Touchscreen Panels High-sensitivity.png")}
                    className="img-fluid w-100 h-100 object-cover"
                    alt="Touchscreen HMI"
                  />
                </div>
                <div className="card-body">
                  <div className="d-flex align-items-center mb-3">
                    <div className="bg-danger bg-opacity-10 p-2 rounded me-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="#dc3545"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm-3.5-3h7a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H11v-1.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5V11h-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5z" />
                      </svg>
                    </div>
                    <h4 className="mb-0">Touchscreen Panels</h4>
                  </div>
                  <p className="fs-6 mb-4 justified-text">
                    High-sensitivity touch interfaces with multi-touch support
                    for intuitive machine control in industrial environments.
                  </p>
                  <ul className="list-unstyled mb-4">
                    <li className="mb-2">
                      <span className="badge bg-light text-dark me-2">✔</span>
                      7"-15" display options
                    </li>
                    <li className="mb-2">
                      <span className="badge bg-light text-dark me-2">✔</span>
                      IP65/66 protection
                    </li>
                    <li>
                      <span className="badge bg-light text-dark me-2">✔</span>
                      Multi-protocol support
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="card h-100 border-0 rounded-4 overflow-hidden shadow-sm hover-shadow-lg transition-all">
                <div
                  className="card-img-top overflow-hidden bg-light"
                  style={{
                    height: "200px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={require("../assets/img/products/Delta/Panel PCs Powerful industrial computers.png")}
                    className="img-fluid w-100 h-100 object-cover"
                    alt="Touchscreen HMI"
                  />
                </div>
                <div className="card-body">
                  <div className="d-flex align-items-center mb-3">
                    <div className="bg-danger bg-opacity-10 p-2 rounded me-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="#dc3545"
                        viewBox="0 0 16 16"
                      >
                        <path d="M5.5 2A3.5 3.5 0 0 0 2 5.5v5A3.5 3.5 0 0 0 5.5 14h5a3.5 3.5 0 0 0 3.5-3.5V8a.5.5 0 0 1 1 0v2.5a4.5 4.5 0 0 1-4.5 4.5h-5A4.5 4.5 0 0 1 1 10.5v-5A4.5 4.5 0 0 1 5.5 1H8a.5.5 0 0 1 0 1H5.5z" />
                        <path d="M16 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                      </svg>
                    </div>
                    <h4 className="mb-0">Panel PCs</h4>
                  </div>
                  <p className="fs-6 mb-4 justified-text">
                    Powerful industrial computers with integrated displays for
                    advanced visualization and control applications.
                  </p>
                  <ul className="list-unstyled mb-4">
                    <li className="mb-2">
                      <span className="badge bg-light text-dark me-2">✔</span>
                      Intel Core processors
                    </li>
                    <li className="mb-2">
                      <span className="badge bg-light text-dark me-2">✔</span>
                      Multi-touch capacitive
                    </li>
                    <li>
                      <span className="badge bg-light text-dark me-2">✔</span>
                      Fanless design
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="card h-100 border-0 rounded-4 overflow-hidden shadow-sm hover-shadow-lg transition-all">
                <div
                  className="card-img-top overflow-hidden bg-light"
                  style={{
                    height: "200px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={require("../assets/img/products/Delta/Mobile Control Wireless solutions-2.png")}
                    className="img-fluid w-100 h-100 object-cover"
                    alt="Touchscreen HMI"
                  />
                </div>
                <div className="card-body">
                  <div className="d-flex align-items-center mb-3">
                    <div className="bg-danger bg-opacity-10 p-2 rounded me-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="#dc3545"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm-3.5-3h7a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H11v-1.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5V11h-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5z" />
                      </svg>
                    </div>
                    <h4 className="mb-0">Mobile Control</h4>
                  </div>
                  <p className="fs-6 mb-4 justified-text">
                    Wireless solutions for remote monitoring and control of
                    industrial processes from mobile devices.
                  </p>
                  <ul className="list-unstyled mb-4">
                    <li className="mb-2">
                      <span className="badge bg-light text-dark me-2">✔</span>
                      iOS/Android support
                    </li>
                    <li className="mb-2">
                      <span className="badge bg-light text-dark me-2">✔</span>
                      Real-time data access
                    </li>
                    <li>
                      <span className="badge bg-light text-dark me-2">✔</span>
                      Secure connectivity
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid border-0 overflow-hidden shadow-lg">
        <div
          className="p-5"
          style={{
            backgroundColor: "#f8f9fa",
            backgroundImage:
              "linear-gradient(to right, #ffffff 0%, #f1f8fe 100%)",
          }}
        >
          {/* Header with gradient accent */}
          <div className="text-center position-relative">
            <h2
              className="fs-1 fw-bold text-gradient"
              style={{
                backgroundImage: "linear-gradient(45deg, #d62d20, #ff6b6b)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Motion Control Systems
            </h2>
            <div
              className="mx-auto"
              style={{
                width: "80px",
                height: "4px",
                background: "linear-gradient(45deg, #d62d20, #ff6b6b)",
                borderRadius: "2px",
              }}
            ></div>
          </div>

          <div className="row g-4 align-items-center">
            {/* Content Column */}
            <div className="col-lg-8" data-aos="fade-left">
              {/* Main Feature Card */}
              <div
                className="card border-0 shadow-sm mb-4"
                style={{
                  background: "rgba(255,255,255,0.8)",
                  backdropFilter: "blur(10px)",
                  borderRadius: "12px",
                }}
              >
                <div className="card-body p-4">
                  <p className="lead fs-6 mb-4 justified-text">
                    Achieve{" "}
                    <span className="fw-bold">high-performance automation</span>{" "}
                    with our advanced servo drives, motors, and motion
                    controllers. Designed for{" "}
                    <span className="fw-bold">
                      precision control, high speed, and reliability
                    </span>
                    , these solutions enhance productivity across industrial
                    applications.
                  </p>

                  <div className="d-flex flex-wrap gap-3 mb-3">
                    <span className="badge bg-danger bg-opacity-10 text-danger py-2 px-3 fs-6 rounded-pill">
                      <i className="bi bi-check-circle-fill me-2"></i>Servo
                      Drives & Motors
                    </span>
                    <span className="badge bg-danger bg-opacity-10 text-danger py-2 px-3 fs-6 rounded-pill">
                      <i className="bi bi-check-circle-fill me-2"></i>Motion
                      Controllers
                    </span>
                    <span className="badge bg-danger bg-opacity-10 text-danger py-2 px-3 fs-6 rounded-pill">
                      <i className="bi bi-check-circle-fill me-2"></i>Precision
                      Control
                    </span>
                  </div>
                </div>
              </div>

              {/* Features Grid */}
              <div className="row g-3">
                <div className="col-md-6">
                  <div
                    className="card h-100 border-0 shadow-sm hover-scale"
                    style={{
                      background:
                        "linear-gradient(135deg, #fff9f9 0%, #ffffff 100%)",
                      borderRadius: "12px",
                    }}
                  >
                    <div className="card-body p-4">
                      <div className="d-flex align-items-center mb-3">
                        <div className="bg-danger bg-opacity-10 p-2 rounded-circle me-3">
                          <i className="bi bi-speedometer2 text-danger fs-4"></i>
                        </div>
                        <h5
                          className="mb-0 text-gradient"
                          style={{
                            backgroundImage:
                              "linear-gradient(45deg, #d62d20, #ff6b6b)",
                          }}
                        >
                          ASDA Series
                        </h5>
                      </div>
                      <ul className="list-unstyled mb-0">
                        <li className="mb-2 d-flex">
                          <i className="bi bi-check-circle-fill text-danger me-2 mt-1"></i>
                          <span>High-speed precision motion control</span>
                        </li>
                        <li className="mb-2 d-flex">
                          <i className="bi bi-check-circle-fill text-danger me-2 mt-1"></i>
                          <span>Advanced tuning for smooth operation</span>
                        </li>
                        <li className="d-flex">
                          <i className="bi bi-check-circle-fill text-danger me-2 mt-1"></i>
                          <span>Energy-efficient design</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div
                    className="card h-100 border-0 shadow-sm hover-scale"
                    style={{
                      background:
                        "linear-gradient(135deg, #f8fbff 0%, #ffffff 100%)",
                      borderRadius: "12px",
                    }}
                  >
                    <div className="card-body p-4">
                      <div className="d-flex align-items-center mb-3">
                        <div className="bg-danger bg-opacity-10 p-2 rounded-circle me-3">
                          <i className="bi bi-cpu text-danger fs-4"></i>
                        </div>
                        <h5
                          className="mb-0 text-gradient text-danger"
                          style={{
                            backgroundImage:
                              "linear-gradient(45deg, #d62d20, #ff6b6b)",
                          }}
                        >
                          Motion Controllers
                        </h5>
                      </div>
                      <ul className="list-unstyled mb-0">
                        <li className="mb-2 d-flex">
                          <i className="bi bi-check-circle-fill text-danger me-2 mt-1"></i>
                          <span>Seamless automation integration</span>
                        </li>
                        <li className="mb-2 d-flex">
                          <i className="bi bi-check-circle-fill text-danger me-2 mt-1"></i>
                          <span>Multi-axis synchronized control</span>
                        </li>
                        <li className="d-flex">
                          <i className="bi bi-check-circle-fill text-danger me-2 mt-1"></i>
                          <span>Customizable programming</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Image Column */}
            <div className="col-lg-4" data-aos="fade-right">
              <div className="position-relative">
                <div
                  className="card border-0 shadow-sm overflow-hidden mb-4"
                  style={{ borderRadius: "16px" }}
                >
                  <img
                    src={require("../assets/img/products/Delta/Motion Control Systems Achieve-2.png")}
                    className="img-fluid p-4"
                    alt="Delta Electronics"
                    style={{
                      background:
                        "linear-gradient(135deg, #f5f7fa 0%, #e4e8ed 100%)",
                    }}
                  />
                </div>
                <div
                  className="card border-0 shadow-sm overflow-hidden"
                  style={{ borderRadius: "16px" }}
                >
                  <img
                    src={require("../assets/img/products/Delta/202202171218493460001-removebg-preview.png")}
                    className="img-fluid p-4"
                    alt="Motion Controller"
                    style={{
                      background:
                        "linear-gradient(135deg, #f5f7fa 0%, #e4e8ed 100%)",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-5 my-5">
        <div className="text-center mb-5">
          <h2 className="fs-1 fw-bold text-gradient-primary">
            Motors <span className="text-muted">(SIMOTICS Series)</span>
          </h2>
        </div>

        <div className="row g-4">
          <div className="col-md-6" data-aos="fade-up">
            <div className="card h-100 border-0 shadow-sm hover-shadow-lg transition-all">
              <div className="overflow-hidden rounded-top">
                <img
                  src={require("../assets/img/products/Delta/Featured Sensors & Meters-1.png")}
                  style={{ height: "400px" }}
                  className="img-fluid w-100 hover-zoom"
                  alt="Sensors & Meters"
                />
              </div>
              <div className="card-body p-4">
                <div className="d-flex align-items-center mb-3">
                  <span className="badge bg-danger me-2">Featured</span>
                  <h5 className="mb-0 fw-bold text-gradient-primary">
                    Sensors & Meters
                  </h5>
                </div>
                <p className="fs-6">
                  Precision monitoring for temperature, pressure, and flow to
                  optimize industrial processes.
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="row g-4">
              <div className="col-12" data-aos="fade-left">
                <div className="card h-100 border-0 shadow-sm hover-shadow transition-all">
                  <div className="row g-0 h-100">
                    <div className="col-md-5">
                      <img
                        src={require("../assets/img/products/Delta/Robot Solutions Delta-1.png")}
                        className="img-fluid h-100 cover-img"
                        alt="Robot Solutions"
                      />
                    </div>
                    <div className="col-md-7">
                      <div className="card-body p-4">
                        <h5 className="fw-bold text-gradient-primary">
                          Robot Solutions
                        </h5>
                        <p className="fs-6">
                          Delta’s robotic arms for assembly, welding, and
                          material handling.
                        </p>
                        <ul className="list-unstyled fs-6 mt-3">
                          <li className="mb-1">✓ SCARA Robots</li>
                          <li className="mb-1">✓ Articulated Robots</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12" data-aos="fade-left">
                <div className="card h-100 border-0 shadow-sm hover-shadow transition-all">
                  <div className="row g-0 h-100">
                    <div className="col-md-5">
                      <img
                        src={require("../assets/img/products/Delta/Power Quality Stable power-1.png")}
                        className="img-fluid h-100 cover-img"
                        alt="Power Quality"
                      />
                    </div>
                    <div className="col-md-7">
                      <div className="card-body p-4">
                        <h5 className="fw-bold text-gradient-primary">
                          Power Quality
                        </h5>
                        <p className="fs-6">
                          Stable power solutions for industrial equipment.
                        </p>
                        <ul className="list-unstyled fs-6 mt-3">
                          <li className="mb-1">✓ UPS Systems</li>
                          <li className="mb-1">✓ Harmonic Filters</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="container-fluid text-darks py-5"
        style={{ backgroundColor: "#E9ECEF" }}
      >
        <div className="container py-4">
          <div className="row g-5">
            <div className="col-lg-5">
              <div className="position-relative">
                <div className="position-relative overflow-hidden rounded-3">
                  <img
                    src={require("../assets/img/products/Delta/Delta Electronics offers a comprehensive-1.png")}
                    alt="Delta Industrial Automation"
                    className="img-fluid"
                    style={{ height: "530px" }}
                  />
                  <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-25"></div>

                  {/* Tech grid overlay */}
                  <div
                    className="position-absolute top-0 start-0 w-100 h-100"
                    style={{
                      backgroundImage:
                        "linear-gradient(rgba(0,123,255,0.15) 1px, transparent 1px), linear-gradient(90deg, rgba(0,123,255,0.15) 1px, transparent 1px)",
                      backgroundSize: "20px 20px",
                    }}
                  ></div>

                  {/* Accent corner */}
                  <div
                    className="position-absolute top-0 end-0 bg-danger"
                    style={{
                      width: "60px",
                      height: "60px",
                      clipPath: "polygon(100% 0, 0 0, 100% 100%)",
                    }}
                  ></div>
                </div>

                {/* Stats card */}
              </div>
            </div>

            <div className="col-lg-7">
              <div className="ps-lg-4">
                {/* Tech-inspired section heading */}
                <div className="d-flex align-items-center mb-4">
                  <div
                    className="bg-danger"
                    style={{ width: "30px", height: "4px" }}
                  ></div>
                  <h6 className="text-uppercase ms-3 text-danger fw-bold mb-0 letter-spacing-2">
                    Premium Solutions
                  </h6>
                </div>

                <h2 className="display-5 fw-bold mb-4">
                  {/* <span className="text-danger">&lt;Delta/&gt;</span> */}
                  <span className="d-block mt-2">Industrial Automation</span>
                </h2>

                <p className="lead fs-6 mb-5">
                  Delta Electronics offers a comprehensive range of industrial
                  automation products designed to enhance manufacturing
                  efficiency and reliability. Our premium solutions deliver
                  performance, durability, and innovation.
                </p>

                {/* Product grid with tech-inspired design */}
                <div className="row g-3">
                  {[
                    {
                      name: "AC Motor Drives",
                      desc: "High performance variable frequency drives",
                    },
                    {
                      name: "Power Regeneration Units",
                      desc: "Energy recovery systems",
                    },
                    {
                      name: "Active Power Filters",
                      desc: "Harmonic mitigation solutions",
                    },
                  ].map((item, index) => (
                    <div className="col-md-6 col-lg-4" key={index}>
                      <div className="card h-100 text-white border rounded-3 hover-border-primary transition-all">
                        <div className="card-body p-4">
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <div className="bg-danger rounded-1 p-2">
                              <div
                                className="bg-white rounded-1"
                                style={{ width: "10px", height: "10px" }}
                              ></div>
                            </div>
                            <span className="text-muted small">
                              0{index + 1}
                            </span>
                          </div>
                          <h5 className="fw-bold text-dark mb-2">
                            {item.name}
                          </h5>
                          <p className="fs-6 text-dark mb-0">{item.desc}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Industrial Control Section with Premium Design */}
      <div className="py-5 bg-light">
        <div className="container py-4">
          <div className="row align-items-center g-5">
            <div
              className="col-lg-6 col-md-6 order-md-2 order-1"
              data-aos="fade-left"
            >
              <div className="ps-md-4">
                <h2
                  className="text-gradient-primary fw-bold  mb-4"
                  data-aos="fade-left"
                >
                  Industrial Control & Communication
                </h2>

                <p className="fs-6 mb-4 justified-text">
                  Delta's Programmable Logic Controllers (PLCs) and industrial
                  communication devices provide efficient and reliable
                  automation solutions, ensuring seamless communication across
                  industrial networks.
                </p>

                <div className="card border-0 shadow-sm rounded-4 mb-4">
                  <div className="card-body p-4">
                    <h5 className="fw-bold mb-4 text-danger d-flex align-items-center">
                      Key Features & Benefits
                    </h5>
                    <ul className="list-unstyled">
                      <li className="mb-3 d-flex">
                        <span
                          className="badge bg-danger rounded-circle d-inline-flex align-items-center justify-content-center me-3"
                          style={{ width: "24px", height: "24px" }}
                        >
                          <FaCheck size={12} />
                        </span>
                        <span>
                          High-performance PLCs for flexible automation
                        </span>
                      </li>
                      <li className="mb-3 d-flex">
                        <span
                          className="badge bg-danger rounded-circle d-inline-flex align-items-center justify-content-center me-3"
                          style={{ width: "24px", height: "24px" }}
                        >
                          <FaCheck size={12} />
                        </span>
                        <span>
                          Seamless integration with industrial Ethernet networks
                        </span>
                      </li>
                      <li className="mb-3 d-flex">
                        <span
                          className="badge bg-danger rounded-circle d-inline-flex align-items-center justify-content-center me-3"
                          style={{ width: "24px", height: "24px" }}
                        >
                          <FaCheck size={12} />
                        </span>
                        <span>
                          Scalable and modular designs for various applications
                        </span>
                      </li>
                      <li className="d-flex">
                        <span
                          className="badge bg-danger rounded-circle d-inline-flex align-items-center justify-content-center me-3"
                          style={{ width: "24px", height: "24px" }}
                        >
                          <FaCheck size={12} />
                        </span>
                        <span>
                          Robust communication protocols for efficient data
                          exchange
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="card border-start border-danger border-4 border-top-0 border-end-0 border-bottom-0 bg-white shadow-sm rounded-end-4">
                  <div className="card-body p-4">
                    <h5 className="fw-bold mb-3">Example Products</h5>
                    <ul className="list-unstyled">
                      <li className="mb-3">
                        <span className="d-block fw-medium text-danger">
                          PLCs (DVP & AS Series)
                        </span>
                        <span className="text-muted">
                          Advanced logic controllers with modular expandability
                        </span>
                      </li>
                      <li className="mb-3">
                        <span className="d-block fw-medium text-danger">
                          Industrial Ethernet Switches
                        </span>
                        <span className="text-muted">
                          High-speed networking solutions for industrial
                          environments
                        </span>
                      </li>
                      <li>
                        <span className="d-block fw-medium text-danger">
                          Remote I/O Modules
                        </span>
                        <span className="text-muted">
                          Efficient data acquisition and control in distributed
                          systems
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="col-lg-6 col-md-6 order-md-1 order-2"
              data-aos="fade-right"
            >
              <div className="position-relative">
                <img
                  className="img-fluid rounded-4 shadow"
                  src={require("../assets/img/products/Delta/Delta Programmable Logic Controllers-1.png")}
                  alt="Industrial Control"
                  style={{ maxHeight: "900px", objectFit: "cover" }}
                />
                <div
                  className="position-absolute bg-danger rounded-4"
                  style={{
                    width: "90%",
                    height: "100%",
                    bottom: "-20px",
                    right: "-20px",
                    zIndex: -1,
                    opacity: 0.05,
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* HMI Section with Glass Morphism Style */}
      <div className="container-fluid px-0 ">
        <div className="container py-5">
          <div className="text-center mb-5" data-aos="fade-up">
            <h1 className="display-6 fw-bold">
              Human Machine <span className="text-danger">Interfaces</span>
            </h1>
            <div
              className="divider bg-danger mx-auto"
              style={{ height: "4px", width: "80px", marginTop: "20px" }}
            ></div>
          </div>

          <div className="row align-items-center ">
            <div className="col-lg-6 order-lg-1 order-2 mb-4 mb-lg-0">
              <div
                className="overflow-hidden rounded-4 shadow-lg position-relative"
                data-aos="fade-right"
              >
                <img
                  className="img-fluid w-100"
                  src={require("../assets/img/products/Delta/Intuitive Control Systems User-1.png")}
                  alt="HMI Interface"
                  style={{ objectFit: "cover", minHeight: "400px" }}
                />
                <div
                  className="position-absolute bottom-0 start-0 w-100 p-4 bg-gradient-dark text-white"
                  style={{
                    background:
                      "linear-gradient(to top, rgba(0,0,0,0.8), rgba(0,0,0,0))",
                    padding: "100px 30px 30px 30px",
                  }}
                >
                  <h5 className="fw-bold">Delta HMI Series</h5>
                  <p className="mb-0">
                    Advanced touchscreen interfaces for industrial control
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-6 order-lg-2 order-1" data-aos="fade-up">
              <div
                className="card border-0 rounded-4 p-4 shadow-lg"
                style={{
                  background: "rgba(255, 255, 255, 0.95)",
                  backdropFilter: "blur(10px)",
                  border: "1px solid rgba(255, 255, 255, 0.2)",
                }}
              >
                <div className="card-body p-3 p-lg-4">
                  <h3 className="text-danger fw-bold mb-4">
                    Intuitive Control Systems
                  </h3>
                  <p className="lead mb-4 fs-6 justified-text">
                    User-friendly interfaces that facilitate intuitive
                    interaction between operators and machines, improving
                    operational efficiency and reducing errors across your
                    production floor.
                  </p>

                  <div className="card border-0 rounded-4 shadow-sm mb-4 bg-light">
                    <div className="card-body p-4">
                      <h4 className="text-danger fw-bold mb-3">
                        More Efficient Production
                      </h4>
                      <p className="mb-4 fs-6 justified-text">
                        Advanced interfaces designed for seamless human-machine
                        interaction, optimizing workflow and minimizing
                        operational mistakes with intuitive controls and
                        visualizations.
                      </p>

                      <div className="bg-white rounded-3 p-3 shadow-sm">
                        <h5 className="fw-bold mb-3">Example Products</h5>
                        <div className="d-flex flex-wrap">
                          <div className="me-4 mb-2 d-flex align-items-center">
                            <span className="text-danger me-2">
                              <FaCheck />
                            </span>
                            <span className="fw-medium">
                              HMI Touch Panels (DOP Series)
                            </span>
                          </div>
                          <div className="mb-2 d-flex align-items-center">
                            <span className="text-danger me-2">
                              <FaCheck />
                            </span>
                            <span className="fw-medium">
                              Industrial Panel PCs
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Motion Control Systems with Modern Design */}
      {/* <div className="py-5" style={{ backgroundColor: "#f8f9fa" }}> */}
      <div className="container py-5">
        <div className="text-center mb-5" data-aos="fade-up">
          <span className="badge bg-danger px-3 py-2 mb-3">
            Precision Control
          </span>
          <h2 className="display-5 fw-bold">
            Motion <span className="text-danger">Control Systems</span>
          </h2>
          <div
            className="divider bg-danger mx-auto"
            style={{ height: "4px", width: "80px", marginTop: "20px" }}
          ></div>
        </div>

        <div className="row g-4">
          <div className="col-lg-8" data-aos="fade-right">
            <div className="card border-0 rounded-4 shadow-sm h-100">
              <div className="card-body p-4 p-lg-5">
                <p className="lead  fs-6 justified-text">
                  Achieve high-performance automation with our advanced servo
                  drives, motors, and motion controllers. Designed to provide
                  precise control, high speed, and reliability, these solutions
                  enhance productivity and product quality across various
                  industrial applications.
                </p>

                <div className="">
                  <h5 className="fw-bold mb-3">Core Products</h5>
                  <div className="d-flex flex-wrap">
                    <div className="me-4 d-flex align-items-center">
                      <span className="text-danger me-2">
                        <FaCheck />
                      </span>
                      <span className="fw-medium">
                        Servo Drives & Motors (ASDA Series)
                      </span>
                    </div>
                    <div className="mb-2 d-flex align-items-center">
                      <span className="text-danger me-2">
                        <FaCheck />
                      </span>
                      <span className="fw-medium">Motion Controllers</span>
                    </div>
                  </div>
                </div>

                <div className="row g-4 mt-2">
                  <div className="col-md-6">
                    <div className="card border-0 rounded-4 h-100 shadow-sm">
                      <div className="card-body p-4">
                        <h5 className="text-danger fw-bold mb-3">
                          Servo Drives & Motors
                        </h5>
                        <ul className="list-unstyled mb-0">
                          <li className="mb-2 d-flex">
                            <span className="text-danger me-2">
                              <FaCheck />
                            </span>
                            <span>
                              High-speed and high-precision motion control
                            </span>
                          </li>
                          <li className="mb-2 d-flex">
                            <span className="text-danger me-2">
                              <FaCheck />
                            </span>
                            <span>
                              Advanced tuning features for smooth operation
                            </span>
                          </li>
                          <li className="d-flex">
                            <span className="text-danger me-2">
                              <FaCheck />
                            </span>
                            <span>
                              Energy-efficient design for cost savings
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="card border-0 rounded-4 h-100 shadow-sm">
                      <div className="card-body p-4">
                        <h5 className="text-danger fw-bold mb-3">
                          Motion Controllers
                        </h5>
                        <ul className="list-unstyled mb-0">
                          <li className="mb-2 d-flex">
                            <span className="text-danger me-2">
                              <FaCheck />
                            </span>
                            <span>
                              Seamless integration with industrial automation
                              systems
                            </span>
                          </li>
                          <li className="mb-2 d-flex">
                            <span className="text-danger me-2">
                              <FaCheck />
                            </span>
                            <span>
                              Multi-axis control for synchronized motion
                            </span>
                          </li>
                          <li className="d-flex">
                            <span className="text-danger me-2">
                              <FaCheck />
                            </span>
                            <span>
                              Customizable programming for various applications
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-4" data-aos="fade-left">
            <div className="card border-0 rounded-4 shadow-sm h-100 overflow-hidden">
              <div className="p-4 bg-white">
                <img
                  className="img-fluid mb-4 w-100"
                  src={require("../assets/img/products/Delta/Motion Control Systems Achieve high-performance.png")}
                  alt="Delta Electronics Logo"
                />
                <img
                  className="img-fluid w-100"
                  src={require("../assets/img/products/Delta/202202171218493460001-removebg-preview.png")}
                  alt="Delta Motion Control"
                />
              </div>
              <div className="card-body bg-danger text-white p-4">
                <h5 className="fw-bold mb-3">Why Choose Delta?</h5>
                <ul className="list-unstyled mb-0">
                  <li className="mb-2 d-flex">
                    <span className="me-2">
                      <FaCheck />
                    </span>
                    <span>Industry-leading precision</span>
                  </li>
                  <li className="mb-2 d-flex">
                    <span className="me-2">
                      <FaCheck />
                    </span>
                    <span>Comprehensive support network</span>
                  </li>
                  <li className="d-flex">
                    <span className="me-2">
                      <FaCheck />
                    </span>
                    <span>Innovative technology solutions</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* </div> */}

      {/* Products Cards with Premium Design */}
      <div className="container py-5">
        <div className="text-center mb-5" data-aos="fade-up">
          <h2 className="display-5 fw-bold">
            Delta <span className="text-danger">Product Range</span>
          </h2>
          <div
            className="divider bg-danger mx-auto"
            style={{ height: "4px", width: "80px", marginTop: "20px" }}
          ></div>
        </div>

        <div className="row row-cols-1 row-cols-md-2 g-4">
          <div className="col" data-aos="fade-up" data-aos-delay="100">
            <div className="card border-0 shadow-lg h-100 rounded-4 overflow-hidden">
              <div className="position-relative">
                <img
                  className="card-img-top"
                  src={require("../assets/img/products/Delta/Sensors & Meters A variety of sensors and.png")}
                  alt="Sensors & Meters"
                  style={{ height: "215px", objectFit: "cover" }}
                />
                {/* <div className="position-absolute top-0 start-0 bg-danger text-white px-3 py-2 m-3 rounded-pill">
                  Premium
                </div> */}
              </div>
              <div className="card-body p-4">
                <h4 className="fw-bold text-danger ">Sensors & Meters</h4>
                <p className="mb-4 fs-6 justified-text">
                  A variety of sensors and meters designed to monitor and
                  collect data on parameters such as temperature, pressure, and
                  flow, essential for process control and optimization.
                </p>
                <h5 className="fw-bold mb-3 small text-uppercase text-secondary">
                  Featured Products
                </h5>
                <ul className="list-unstyled mb-0">
                  <li className="mb-2 d-flex">
                    <span className="text-danger me-2">
                      <FaChevronRight />
                    </span>
                    <span>Temperature Controllers</span>
                  </li>
                  <li className="d-flex">
                    <span className="text-danger me-2">
                      <FaChevronRight />
                    </span>
                    <span>Industrial Sensors</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="col" data-aos="fade-up" data-aos-delay="200">
            <div className="card border-0 shadow-lg h-100 rounded-4 overflow-hidden">
              <div className="position-relative">
                <img
                  className="card-img-top"
                  src={require("../assets/img/products/Delta/Delta offers robotic arms and.png")}
                  alt="Robot Solutions"
                  style={{ height: "215px", objectFit: "cover" }}
                />
                {/* <div className="position-absolute top-0 start-0 bg-danger text-white px-3 py-2 m-3 rounded-pill">
                  Premium
                </div> */}
              </div>
              <div className="card-body p-4">
                <h4 className="fw-bold text-danger">Robot Solutions</h4>
                <p className="mb-4 fs-6 justified-text">
                  Delta offers robotic arms and automation solutions tailored
                  for tasks like assembly, welding, and material handling,
                  contributing to increased automation and reduced labor costs.
                </p>
                <h5 className="fw-bold mb-3 small text-uppercase text-secondary">
                  Featured Products
                </h5>
                <ul className="list-unstyled mb-0">
                  <li className="mb-2 d-flex">
                    <span className="text-danger me-2">
                      <FaChevronRight />
                    </span>
                    <span>SCARA Robots</span>
                  </li>
                  <li className="d-flex">
                    <span className="text-danger me-2">
                      <FaChevronRight />
                    </span>
                    <span>Articulated Robots</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="col" data-aos="fade-up" data-aos-delay="300">
            <div className="card border-0 shadow-lg h-100 rounded-4 overflow-hidden">
              <div className="position-relative">
                <img
                  className="card-img-top"
                  src={require("../assets/img/products/Delta/Power Quality Improvement Products in this category.png")}
                  alt="Power Quality Improvement"
                  style={{ height: "215px", objectFit: "cover" }}
                />
                {/* <div className="position-absolute top-0 start-0 bg-danger text-white px-3 py-2 m-3 rounded-pill">
                  Premium
                </div> */}
              </div>
              <div className="card-body p-4">
                <h4 className="fw-bold text-danger ">
                  Power Quality Improvement
                </h4>
                <p className="mb-4 fs-6 justified-text">
                  Products in this category are designed to enhance the quality
                  of power in industrial systems, ensuring stable and efficient
                  operation of equipment.
                </p>
                <h5 className="fw-bold mb-3 small text-uppercase text-secondary">
                  Featured Products
                </h5>
                <ul className="list-unstyled mb-0">
                  <li className="mb-2 d-flex">
                    <span className="text-danger me-2">
                      <FaChevronRight />
                    </span>
                    <span>Uninterruptible Power Supplies (UPS)</span>
                  </li>
                  <li className="d-flex">
                    <span className="text-danger me-2">
                      <FaChevronRight />
                    </span>
                    <span>Harmonic Filters</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="col" data-aos="fade-up" data-aos-delay="400">
            <div className="card border-0 shadow-lg h-100 rounded-4 overflow-hidden">
              <div className="position-relative">
                <img
                  className="card-img-top"
                  src={require("../assets/img/products/Delta/Industrial Software Software solutions for monitoring-1.png")}
                  alt="Industrial Software"
                  style={{ height: "215px", objectFit: "cover" }}
                />
                {/* <div className="position-absolute top-0 start-0 bg-danger text-white px-3 py-2 m-3 rounded-pill">
                  Premium
                </div> */}
              </div>
              <div className="card-body p-4">
                <h4 className="fw-bold text-danger">Industrial Software</h4>
                <p className="mb-4 fs-6 justified-text">
                  Software solutions for monitoring, control, and data analysis,
                  including SCADA systems and industrial energy management
                  systems, supporting smart manufacturing initiatives.
                </p>
                <h5 className="fw-bold mb-3 small text-uppercase text-secondary">
                  Featured Products
                </h5>
                <ul className="list-unstyled mb-0">
                  <li className="mb-2 d-flex">
                    <span className="text-danger me-2">
                      <FaChevronRight />
                    </span>
                    <span>SCADA & Monitoring Software</span>
                  </li>
                  <li className="d-flex">
                    <span className="text-danger me-2">
                      <FaChevronRight />
                    </span>
                    <span>Energy Management Systems</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Delta;
